"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Image_1 = __importDefault(require("../Image"));
var ImageLoader_1 = __importDefault(require("./ImageLoader"));
function ImageBuffer(props) {
    var _a = (0, react_1.useState)(false), loaded = _a[0], setLoaded = _a[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledImage, __assign({}, props, { loaded: loaded, onLoad: function (event) {
                var _a;
                setTimeout(function () {
                    setLoaded(true);
                }, 50); // give some time for state to be false first if it's cached
                (_a = props.onLoad) === null || _a === void 0 ? void 0 : _a.call(// give some time for state to be false first if it's cached
                props, event);
            } })),
        !loaded && react_1.default.createElement(ImageLoader_1.default, null)));
}
exports.default = ImageBuffer;
var StyledImage = (0, styled_1.default)(Image_1.default)(function (_a) {
    var loaded = _a.loaded, duration = _a.duration;
    return ({
        position: 'absolute',
        top: 0,
        left: 0,
        transitionDuration: duration ? duration.toString() + "s" : '1s',
        transitionProperty: 'opacity',
        opacity: loaded ? 1 : 0
    });
});
